import { stringifyEntityRef } from "@backstage/catalog-model";
import { InfoCard } from "@backstage/core-components";
import { identityApiRef, useApi } from "@backstage/core-plugin-api";
import { useEntity } from "@backstage/plugin-catalog-react";
import { Button } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { stringify } from "yaml";

/**
 * Card component that enables users to create an automated pull request
 * to update the configuration for the current entity.
 */
export const EntityScaffolderCard = () => {
  const { entity } = useEntity();
  const navigate = useNavigate();
  const identityApi = useApi(identityApiRef);

  // Template namespace and name - customize as needed
  const templateNamespace = "default";
  const templateName = "update-entity-overlay";

  const handleLaunchTemplate = async () => {
    const profileInfo = await identityApi.getProfileInfo();

    const entityContent = stringify(entity, { indent: 4, lineWidth: 120 });
    const entityRef = stringifyEntityRef(entity);

    const formData = {
      entityContent,
      entityRef,
      userName: profileInfo.displayName || undefined,
      userEmail: profileInfo.email || undefined,
    };

    const queryParams = new URLSearchParams({
      formData: JSON.stringify(formData),
    });
    navigate(
      `/create/templates/${templateNamespace}/${templateName}?${queryParams}`,
    );
  };

  return (
    <InfoCard title="Update Configuration" variant="gridItem">
      <div style={{ padding: "16px" }}>
        <p>
          Create an automated pull request to update the configuration file for
          this entity. The PR will be pre-configured with the entity details.
        </p>
        <Button
          variant="contained"
          color="primary"
          onClick={handleLaunchTemplate}
          style={{ marginTop: "16px" }}
        >
          Create PR
        </Button>
      </div>
    </InfoCard>
  );
};
